export const CHAT_UNREAD_CHANGED = 'chat-unread-changed';

export const sumUnreadFromChatList = (list) => {
    if (!Array.isArray(list)) {
        return 0;
    }
    let total = 0;
    for (let i = 0; i < list.length; i += 1) {
        const count = Number(list[i]?.un_seen_count);
        if (Number.isFinite(count) && count > 0) {
            total += Math.floor(count);
        }
    }
    return total;
};

export const notifyChatUnreadChanged = (totalUnread) => {
    if (typeof window === 'undefined') {
        return;
    }
    const detail = {};
    if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
        detail.totalUnread = Math.max(0, Math.floor(totalUnread));
    }
    window.dispatchEvent(new CustomEvent(CHAT_UNREAD_CHANGED, { detail }));
};
